<template>
    <div class="account">
        <div class="title">
            <el-breadcrumb >
                <el-breadcrumb-item :to="{ path: '/home/fixShopList' }">返回店铺列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="品牌介绍" name="info" :class="activeName == 'info' ? 'marginUn' : ''">
                    <fixBrand />
                </el-tab-pane>
                <el-tab-pane label="推荐商品" name="is_recom" >
                   <fixGoods ref="fixGood" />
                </el-tab-pane>
                <el-tab-pane label="店铺分类" name="sort">
                   <fixShopSort ref='fixsort'></fixShopSort>
                </el-tab-pane>
                <!-- <el-tab-pane label="仓库管理" name="warehouse">
                    <warehouse ref="refWarehouse" @edit="edit" @detail="detail"/>
                </el-tab-pane> -->
            </el-tabs>
        </div>


     
    </div>
</template>
<script>
import fixBrand from '@/components/Modules/ShopManage/fixBrand.vue'
import fixGoods from '@/components/Modules/ShopManage/fixGoods.vue'
import fixShopSort from '@/components/Modules/ShopManage/fixShopSort.vue'
export default {
    data() {
        return {
            activeName: "info",
          
        };
    },
    components: {
      fixBrand,
      fixGoods,
      fixShopSort
    },
    
    created() {
     
    },
    methods: {
        handleClick(tab, event) {
         if(this.activeName=='is_recom'){
         this.$refs.fixGood.getdecorateGoodsList()
         }else if(this.activeName=='sort'){
            this.$refs.fixsort.getdecorateSortList()
         }
          console.log(this.activeName,'tab')
        },
       
    },
};
</script>
<style lang='scss' scoped>
.check {
    margin-right: 4px;
    margin-top: 2px;
}
.title {
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
}

.main {
    min-height: 760px;
    box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
    background: #fff;
    margin: 24px;
    padding: 20px;
    padding-bottom: 70px;
    min-width: 1200px;
}

.marginUn {
    .info {
        margin: unset !important;
    }
}


</style>